import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ContactProfile } from 'src/app/api';
import { Subscription } from 'rxjs';
import { map, startWith, switchMap, tap } from 'rxjs/operators';
import { UiRouterState } from '../../../services/ajs-router-state.service';
import { ProfileContactsService } from '../../../services/profile/profile-contacts.service';

const REQUIRED_CONTACTS: ContactProfile[] = [
  ContactProfile.Atendimento,
  ContactProfile.Expedição,
  ContactProfile.Financeiro,
];

@Component({
  selector: 'mandae-profile-contacts-step',
  templateUrl: './profile-contacts.component.html',
  styleUrls: ['./profile-contacts.component.scss']
})
export class ProfileContactsComponent implements OnInit, OnDestroy {

  @Input() number = 1;

  @Input()
  public get missingContacts(): ContactProfile[] {
    return this._missingContacts;
  }
  public set missingContacts(value: ContactProfile[]) {
    this._missingContacts = value;
    this.missingContactsChange.emit(value);
  }
  private _missingContacts: ContactProfile[] = REQUIRED_CONTACTS;
  @Output() missingContactsChange = new EventEmitter<ContactProfile[]>();

  @Input()
  public get complete(): boolean {
    return this._complete;
  }
  public set complete(value: boolean) {
    if (this._complete !== value) {
      this._complete = value;
      this.completeChange.emit(value);
    }
  }
  private _complete = false;
  @Output() completeChange = new EventEmitter<boolean>();

  private profileUpdateSubscription: Subscription;

  constructor(
    private profileContacts: ProfileContactsService,
    private router: UiRouterState,
  ) { }

  public ngOnInit(): void {
    this.profileUpdateSubscription = this.profileContacts.shouldUpdate
      .pipe(
        startWith({}),
        switchMap(() => this.profileContacts.getContacts()),
        map(contacts =>
          REQUIRED_CONTACTS.filter(profile =>
            !contacts.some(contact => contact.perfil === profile)
          )
        ),
        tap(missingContacts => {
          this.complete = missingContacts.length === 0;
          this.missingContacts = missingContacts;
        }),
      )
      .subscribe();
  }

  public ngOnDestroy(): void {
    this.profileUpdateSubscription.unsubscribe();
  }

  public goToContactsPage(): void {
    this.router.go('contato', { abrirModalSetupContatos: true }, { reload: true });
  }

}
